class WorkController {

    constructor() {
        this.model = plannerApplication.studyPlannerProfile.getWork();
        this.view = new WorkView(
            this.onOfficeTimeSelectionChanged.bind(this),
            this.onOfficeDurationSelectionChanged.bind(this),
            this.onOfficeDaySelectionChanged.bind(this),
            this.onFromHomeTimeSelectionChanged.bind(this),
            this.onFromHomeDurationSelectionChanged.bind(this),
            this.onFromHomeDaySelectionChanged.bind(this)
        );

        this.view.inOffice.updateSelected(
            this.model.getStartTimeInOffice(),
            this.model.getDurationInOffice(),
            this.model.getDaysAWeekInOffice());
        
        this.view.fromHome.updateSelected(
            this.model.getStartTimeFromHome(), 
            this.model.getDurationFromHome(),
            this.model.getDaysAWeekFromHome());
    }

    onOfficeTimeSelectionChanged(time) {
        this.model.setStartTimeInOffice(time);
        plannerApplication.userDataUpdated();
    }
    
    onOfficeDurationSelectionChanged(minutes) {
        this.model.setDurationInOffice(minutes);
        plannerApplication.userDataUpdated();
    }

    onOfficeDaySelectionChanged(days) {
        this.model.setDaysAWeekInOffice(days);
        plannerApplication.userDataUpdated();
    }


    onFromHomeTimeSelectionChanged(time) {
        this.model.setStartTimeFromHome(time);
        plannerApplication.userDataUpdated();
    }

    onFromHomeDurationSelectionChanged(minutes) {
        this.model.setDurationFromHome(minutes);
        plannerApplication.userDataUpdated();
    }

    onFromHomeDaySelectionChanged(days) {
        this.model.setDaysAWeekFromHome(days);
        plannerApplication.userDataUpdated();
    }
}
